import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./index.css";

// Hand-tuned sprinkle field. Coordinates are percentages relative to the
// sprinkle layer (which extends slightly beyond the pill on every side).
// Each sprinkle is centered on its (x, y) via translate(-50%, -50%) in CSS,
// so coordinates describe the dot's center, not its top-left corner.
const SPRINKLES = [
    // Above the pill
    { type: "star", tone: "c1", x: 12, y:  4, size: 14, delay: 0.00, dur: 1.7 },
    { type: "orb",  tone: "c2", x: 38, y:  8, size: 5,  delay: 0.45, dur: 2.0 },
    { type: "star", tone: "c3", x: 64, y:  2, size: 11, delay: 0.20, dur: 1.5 },
    { type: "orb",  tone: "c4", x: 88, y: 12, size: 4,  delay: 0.85, dur: 1.9 },
    // Below the pill
    { type: "orb",  tone: "c1", x:  8, y: 88, size: 4,  delay: 0.60, dur: 1.8 },
    { type: "star", tone: "c2", x: 32, y: 95, size: 10, delay: 0.10, dur: 1.6 },
    { type: "orb",  tone: "c3", x: 56, y: 84, size: 6,  delay: 0.75, dur: 2.1 },
    { type: "star", tone: "c4", x: 78, y: 92, size: 12, delay: 0.35, dur: 1.5 },
    // Flanking the pill horizontally
    { type: "star", tone: "c2", x:  0, y: 50, size:  9, delay: 0.55, dur: 1.6 },
    { type: "star", tone: "c3", x: 100, y: 50, size: 9, delay: 1.00, dur: 1.6 },
];

const BackToMuzoneButton = ({
    to = "/login",
    children = "Back to MUZONE",
    className = "",
    ...rest
}) => {
    const composedClassName = ["back-to-muzone", className].filter(Boolean).join(" ");

    return (
        <Link to={to} className={composedClassName} {...rest}>
            <span className="back-to-muzone__sprinkles" aria-hidden="true">
                {SPRINKLES.map((s, i) => (
                    <span
                        key={i}
                        className={[
                            "back-to-muzone__sprinkle",
                            `back-to-muzone__sprinkle--${s.type}`,
                            `back-to-muzone__sprinkle--tone-${s.tone}`,
                        ].join(" ")}
                        style={{
                            left: `${s.x}%`,
                            top: `${s.y}%`,
                            width: `${s.size}px`,
                            height: `${s.size}px`,
                            "--bm-delay": `${s.delay}s`,
                            "--bm-dur": `${s.dur}s`,
                        }}
                    />
                ))}
            </span>
            <span className="back-to-muzone__shine" aria-hidden="true" />
            <span className="back-to-muzone__arrow" aria-hidden="true">←</span>
            <span className="back-to-muzone__label">{children}</span>
        </Link>
    );
};

BackToMuzoneButton.propTypes = {
    to: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
};

export default BackToMuzoneButton;
